import request from '@/api/request'

export function sendSmsCode(data) {
  let req = {
    mobile: data,
    businessType: 2
  }
  return request({
    url: 'webapi/smsCode/sendSmsCode',
    method: 'post',
    data: req,
  })
}
